/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_ManageInputs */

const en_directory_submit_check_manage = /** @type {(inputs: Directory_Submit_Check_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage in My Tools`)
};

const zh_directory_submit_check_manage = /** @type {(inputs: Directory_Submit_Check_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 My Tools 中管理`)
};

/**
* | output |
* | --- |
* | "Manage in My Tools" |
*
* @param {Directory_Submit_Check_ManageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_manage = /** @type {((inputs?: Directory_Submit_Check_ManageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_ManageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_manage(inputs)
	return zh_directory_submit_check_manage(inputs)
});
export { directory_submit_check_manage as "directory.submit.check.manage" }